import {
    get,
    put,
    post,
    Delete
  } from "../ApiDecorator"; // 倒入 api
  // 单独倒出
  const ocr = {
    // ocr列表
    getList(data) {
      return get("/quest/ocr/getList",data);
    },
    // 开始识别
    startRecognize(data){
        return post('/quest/ocr/startRecognize',data)
    },
    // ocr详情人员列表
    getOneList(data){
        return get('/quest/ocr/getOneList',data)
    },
    // ocr单个学员详情
    getOneListDetail(data){
        return get('/quest/ocr/getOneListDetail',data)
    },
    // ocr 获取作业的识别结果 学用于作业展示
    getOcrByQuest(data){
        return get('/quest/ocr/getOcrByQuest',data)
    },
    // ocr 编辑识别内容
    editOcrResult(data){
        return put('/quest/ocr/editOcrResult',data)
    },
    // 开始识别(单个作业) 
    startRecognizeOne(data){
        return get('/quest/ocr/startRecognizeOne',data)
    },
    // ocr下载 
    ocrdownload(data){
        return get('/quest/ocr/download',data)
    },
    // ocr 获取识别记录的识别模式 
    getRecognizeMode(data){
        return get('/quest/ocr/getRecognizeMode',data)
    }
  };
  
  // 默认全部倒出
  export default ocr;